import { AppPaths } from "@/shared/common/enums";

export enum TemplateApiUrls {
  Templates = "/v1/Transactions/Templates",
  CheckName = "/v1/Transactions/Templates/Check-Name",
  AccountTransferTemplateV2 = "/v2/AccountTransfer/Templates",
  CardTransferTemplateV2 = "/v2/CardTransfer/Templates",
  OwnAccountTransferTemplateV2 = "/v2/OwnAccountTransfer/Templates",
  CurrencyExchangeTemplateV2 = "/v2/CurrencyExchange/Templates",
  LoanRepaymentTemplateV2 = "/v2/LoanRepayment/Templates",
  BudgetTransferTemplateV2 = "/v2/BudgetTransfer/Templates",
}

export enum Paths {
  Templates = "templates",
  AccountTransferTemplate = "account-transfer",
  AccountTransferTemplateUpdate = "account-transfer/:operationId/update",
  CardTransferTemplate = "card-transfer",
  CardTransferTemplateUpdate = "card-transfer/:operationId/update",
  OwnTransferTemplate = "own-transfer",
  OwnTransferTemplateUpdate = "own-transfer/:operationId/update",
  CurrencyExchangeTemplate = "currency-exchange",
  CurrencyExchangeTemplateUpdate = "currency-exchange/:operationId/update",
  LoanRepaymentTemplate = "loan-repayment",
  LoanRepaymentTemplateUpdate = "loan-repayment/:operationId/update",
  BudgetTransferTemplate = "budget-transfer",
  BudgetTransferTemplateUpdate = "budget-transfer/:operationId/update",
}

export enum TemplatesTab {
  Transfers = "transfers",
  Payments = "payments",
  Groups = "groups",
}

export enum TransferFeatureToggles {
  CardTransfer = "isCardTransferAvailable",
  BudgetTransfer = "isBudgetTransferAvailable",
  AccountTransfer = "isAccountTransferAvailable",
  OwnAccountTransfer = "isOwnAccountTransferAvailable",
  CurrencyExchange = "isCurrencyExchangeAvailable",
  GroupTransfer = "isGroupTransferAvailable",
  LoanRepayment = "isLoanRepaymentAvailable",
}

export enum TemplateFeatureToggles {
  CardTransfer = "isCardTransferAvailable",
  BudgetTransfer = "isBudgetTransferTemplateAvailable",
  AccountTransfer = "isAccountTransferAvailable",
  OwnAccountTransfer = "isOwnAccountTransferAvailable",
  CurrencyExchange = "isCurrencyExchangeAvailable",
  LoanRepayment = "isLoanRepaymentAvailable",
}

export const TransactionOpeningRoutes: { [key: string]: AppPaths } = {
  AccountTransfer: AppPaths.AccountTransfer,
  CardTransfer: AppPaths.CardTransfer,
  OwnAccountTransfer: AppPaths.OwnAccountTransfer,
  CurrencyExchange: AppPaths.CurrencyExchange,
  LoanRepayment: AppPaths.LoanRepayment,
  BudgetTransfer: AppPaths.BudgetTransfer,
  // GroupTransfer: AppPaths.GroupTransfer,
};

export const TemplateOpeningRoutes: { [key: string]: AppPaths } = {
  AccountTransfer: AppPaths.AccountTransferTemplate,
  CardTransfer: AppPaths.CardTransferTemplate,
  OwnAccountTransfer: AppPaths.OwnAccountTransferTemplate,
  CurrencyExchange: AppPaths.CurrencyExchangeTemplate,
  LoanRepayment: AppPaths.LoanRepaymentTemplate,
  BudgetTransfer: AppPaths.BudgetTransferTemplate,
};
